import router from "@/router";
import store from "@/store";
import axios from "axios";
import { getToken, reload, getSetTimes } from "./permissimport";
import { removeToken } from "@/utils/auth";
const whiteList = [
  "RankPicc",
  "Course",
  "ActionEnd",
  "ActionPre",
  "mkptoxd",
  "VoteHomeOutofWX",
  "PublicUserDetailsOutofWX",
  "mkptoxdUserDetails",
  "SelectSubject",
  "RematchSubjectList",
]; // 白名单，不需要验证，直接通行！
let isRequest = true;
router.beforeEach(async (to, from, next) => {
  //  添加白名单，不需要经过验证的直接过
  if (whiteList.indexOf(to.name) >= 0) {
    if (!to.query.t) {
      next({ ...to, query: { ...to.query, t: Date.now() } });
    } else {
      next();
    }
  } else if (!localStorage.getItem("token")) {
    getToken(to);
  } else {
    // 视频上传状态检查 - 在请求配置前先检查store中是否已有状态
    if (!isRequest && to.name === "UserDetails" && store.state.deadline_video_status === 2) {
      next({ path: "UserDetailsClose", query: to.query });
      return;
    }
    if (!isRequest && to.name === "UserDetailsClose" && store.state.deadline_video_status === 1) {
      next({ path: "UserDetails", query: to.query });
      return;
    }
    
    if (isRequest) {
      isRequest = false;
      let times = await getSetTimes();

      let reqData = times.data.data;
      store.commit("setReportTime", reqData.apple_start_at);
      store.commit("setReportEndTime", reqData.apple_end_at);
      store.commit("setRematchTime", reqData.semi_final_start_at);
      store.commit("setRematchEndTime", reqData.semi_final_end_at);
      store.commit("setDeadline_video_date", reqData.deadline_video_date);
      store.commit("setDeadline_video_status", reqData.deadline_video_status);

      // 验证token是否有效放在了request中，这里只验证一次
      let locToken = localStorage.getItem("token");
      let res = await axios({
        method: "get",
        url: "/api/v1/token/verify-token?token=" + locToken,
      });
      if (res.data.data.isValid) {
        if (!to.query.t) {
          next({ ...to, query: { ...to.query, t: Date.now() } });
        } else {
          next();
        }
      } else {
        //无效token 直接清除，刷新界面
        removeToken();
        reload();
      }
    } else {
      if (!to.query.t) {
        next({ ...to, query: { ...to.query, t: Date.now() } });
      } else {
        next();
      }
    }
  }
});
router.afterEach((to, from) => {
  to.query.t = Date.now();
});
